import React, { FC } from 'react';
import { ui } from 'util/ui';

/**
 * Small square icon button for record and file rows (UI refresh), matching the project cards:
 * rounded, thin border, stroke icon. `dark` is for the charcoal bar of an open record.
 */
const RowIconButton: FC<{ label: string; onClick(): void; dark?: boolean; danger?: boolean; disabled?: boolean }> = ({
  label,
  onClick,
  dark = false,
  danger = false,
  disabled = false,
  children,
}) => (
  <button
    type="button"
    className="archy-btn"
    aria-label={label}
    title={label}
    disabled={disabled}
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    style={{
      width: 32,
      height: 32,
      flex: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      borderRadius: 8,
      border: dark ? '1px solid rgba(255,255,255,0.22)' : `1px solid ${danger ? '#E8B4B0' : ui.control}`,
      background: dark ? 'rgba(255,255,255,0.08)' : ui.surface,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
    }}
  >
    {children}
  </button>
);

export default RowIconButton;
